import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getAxios } from "../Services/commonService";
import { API_INSTRUMENT_BADLA_LIST } from "../utils/api/ApiConstant";

const useBadlaType = () => {
  const { isLoading, data: badlaListData } = useQuery({
    queryKey: ["badlaListData"],
    queryFn: () =>
      getAxios({
        url: API_INSTRUMENT_BADLA_LIST,
        params: {},
      }),
    staleTime: 60000,
  });

  const BLANK_OPTION = { label: "None", value: null };

  const badlaModifyOptionsWithoutBlank = useMemo(() => {
    return badlaListData
      ? badlaListData
          .filter((x) => x.isActive)
          .map((val) => ({
            label: `${val.original_exchange}-${val.name} [${val.expiry}]`,
            value: val.instrument_token,
          }))
      : [];
  }, [badlaListData]);

  const badlaModifyOptions = useMemo(() => {
    return [BLANK_OPTION, ...badlaModifyOptionsWithoutBlank];
  }, [badlaModifyOptionsWithoutBlank]);

  return { badlaModifyOptions, badlaListData };
};

export default useBadlaType;
